module.exports = __webpack_public_path__ + "images/corporate_buybacks_lp/icon_step_arrow_8c59282bb3a13562d4f4a30416abcdc6.png";